module.exports = __webpack_public_path__ + "img/voice.e033647f.svg";